(() => {
  const end = Date.parse('2026-11-01T00:00:00-04:00');
  let reloadScheduled = false;
  function check() {
    if (Date.now() < end) return;
    const badges = document.querySelectorAll('[data-ff-hot-buy-end]');
    badges.forEach(badge => { badge.hidden = true; });
    if (badges.length && !reloadScheduled) {
      reloadScheduled = true;
      window.setTimeout(() => window.location.reload(), 75000);
    }
  }
  check();
  window.setInterval(check, 30000);
  document.addEventListener('visibilitychange', check);
  window.addEventListener('pageshow', check);
})();
